import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CartboxButton from '../cartbox-button'
import TechnicalDataIcon from '../../assets/media/icons/tech.svg'

export type Props = {
    openInfoModal: (modalData: any) => void
    configurationString: string
    modelName: string
}

const TechnicalDataButton: FunctionComponent<Props> = ({
    openInfoModal,
    configurationString,
    modelName,
}) => {
    const { t } = useTranslation()

    const handleClick = () => {
        openInfoModal({
            title: modelName,
            media: [],
            technicalDataConfigurationString: configurationString,
        })
    }

    return (
        <CartboxButton onClick={handleClick} dataTestId="technical-data-button"
            icon={<TechnicalDataIcon />}
            label={t('technicalDataView.heading')}>
        </CartboxButton>
    )
}

export default TechnicalDataButton
